
import Vue from 'vue'

export default Vue.extend({
  name: 'ConfiguratorMobileCategoryHeading',
  props: {
      heading: String,
      collapseId: String
  }
})
